import React from 'react';
import {
  FaBullhorn,
  FaChartLine,
  FaDumbbell,
  FaLaptopCode,
  FaPalette,
  FaPiggyBank,
  FaRocket,
  FaServer
} from 'react-icons/fa';

const categoryIcons = {
  Desarrollo: FaLaptopCode,
  Negocios: FaChartLine,
  Finanzas: FaPiggyBank,
  'TI y Software': FaServer,
  Productividad: FaRocket,
  'Diseño': FaPalette,
  Marketing: FaBullhorn,
  'Salud y Fitness': FaDumbbell
};

const CategoriesSection = ({
  categories,
  selectedCategory,
  onSelectCategory
}) => {
  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between gap-4 mb-8">
          <h2 className="text-3xl font-bold text-center flex-1">Explora nuestras categorias</h2>
          {selectedCategory ? (
            <button
              type="button"
              onClick={() => onSelectCategory(null)}
              className="hidden md:inline-flex px-4 py-2 rounded-full border border-gray-300 text-sm font-semibold text-gray-700 hover:bg-white"
            >
              Ver todas
            </button>
          ) : null}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-6">
          {categories.map((category) => {
            const Icon = categoryIcons[category.name] || FaLaptopCode;
            const isSelected = selectedCategory === category.name;

            return (
              <button
                key={category.key}
                type="button"
                onClick={() => onSelectCategory(isSelected ? null : category.name)}
                className={`flex flex-col items-center text-center p-4 bg-white rounded-lg shadow-sm transition-all ${
                  isSelected
                    ? 'ring-2 ring-blue-500 shadow-md -translate-y-1'
                    : 'hover:shadow-md'
                }`}
              >
                <span className="text-4xl mb-2 text-blue-600">
                  <Icon />
                </span>
                <h3 className="font-semibold text-lg">{category.name}</h3>
                <span className="mt-2 text-xs text-gray-500">
                  {category.courseCount || 0} curso{category.courseCount === 1 ? '' : 's'}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
